/*
  df-price.js — resolves <span class="df-price" data-handle="..." data-variant="...">fallback</span>
  to the buyer's own market price. Contract fixed 2026-08-16 by the hub:
  ../../../../darkforesthub/workspace/pricing/2026-08-16_hardcoded-prices-audit.md,
  section "The placeholder contract". The article department is building to the same
  contract at the same time, so nothing here may be renegotiated unilaterally.

  SAFETY CONTRACT (same pattern as snippets/df-inarticle-buy.liquid):
    * Touches ONLY elements matching .df-price[data-handle] — nothing else on the page.
    * One IIFE, try/catch at every boundary. Any failure leaves the fallback sentence exactly
      as written in the HTML — never an empty string, never "NaN", never a broken symbol.
    * No dependency on jQuery, theme JS or any app — native fetch + Intl only.
    * Included once in layout/theme.liquid, which is the layout every JSON template in this
      theme resolves to (checked 2026-08-16: no "layout" override in article.json, page.json,
      product.json, blog.json or index.json) — so it runs on articles, products and pages alike.

  KNOWN LIMIT, not a bug in this file: Shopify translates variant `title` per market — verified
  2026-08-16, the same Moonlight variant reads "Deck Only" on the root market and "Solo baraja" on
  /es-es/. A data-variant value is always written in English, so on a non-English market a named
  match will not find it and the span falls back to the product's lowest price — which is exactly
  the fallback the contract itself specifies for a non-matching name (see the audit file). Flagged
  in the deliverable rather than patched here: fixing it would mean changing the shared contract
  (e.g. to a stable variant id) after the article side has already started building to the name.
*/
(function () {
  "use strict";

  function priceRoot() {
    try {
      if (window.__DF_PRICE_ROOT__ && typeof window.__DF_PRICE_ROOT__ === "string") {
        var r = window.__DF_PRICE_ROOT__;
        return r.charAt(r.length - 1) === "/" ? r : r + "/";
      }
    } catch (e) {}
    return "/";
  }

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: "currency",
        currency: currency || "USD"
      }).format(cents / 100);
    } catch (e) {
      return (currency ? currency + " " : "") + (cents / 100).toFixed(2);
    }
  }

  function pickVariant(json, wantName) {
    var variants = (json && json.variants) || [];
    if (!variants.length) return null;
    if (wantName) {
      var want = String(wantName).trim().toLowerCase();
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var t1 = (v.title || "").trim().toLowerCase();
        var t2 = (v.public_title || "").trim().toLowerCase();
        if (t1 === want || t2 === want) return v;
      }
    }
    var low = variants[0];
    for (var j = 1; j < variants.length; j++) {
      if (typeof variants[j].price === "number" && variants[j].price < low.price) low = variants[j];
    }
    return low;
  }

  function apply(el, json) {
    try {
      var v = pickVariant(json, el.getAttribute("data-variant"));
      if (!v || typeof v.price !== "number") return; // leave the fallback sentence as written
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "USD";
      el.textContent = formatMoney(v.price, currency);
      el.setAttribute("data-df-resolved", "1");
    } catch (e) { /* leave the fallback sentence as written */ }
  }

  function run() {
    try {
      var nodes = document.querySelectorAll(".df-price[data-handle]");
      if (!nodes.length) return; // nothing on this page uses the mechanism
      var base = priceRoot();
      var cache = {};
      for (var i = 0; i < nodes.length; i++) {
        (function (el) {
          var handle = el.getAttribute("data-handle");
          if (!handle) return;
          if (!cache[handle]) {
            cache[handle] = fetch(base + "products/" + handle + ".js", {
              headers: { Accept: "application/json" },
              credentials: "same-origin"
            }).then(function (r) {
              if (!r.ok) throw new Error("df-price: " + r.status + " for " + handle);
              return r.json();
            });
          }
          cache[handle]
            .then(function (json) { apply(el, json); })
            ["catch"](function () { /* fetch failed — leave the fallback sentence as written */ });
        })(nodes[i]);
      }
    } catch (e) { /* mechanism absent, page untouched */ }
  }

  function boot() { try { run(); } catch (e) {} }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
})();
